module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("chip-status status-" + _vm.cleanState + " " + _vm.size),
    style: (_vm.styleRoom)
  }, [(_vm.extraState) ? _c('span', {
    class: ("extra-state sprite-states " + _vm.extraState)
  }) : _vm._e(), _vm._v(" "), (_vm.isAdded && !_vm.room.isSelected) ? _c('button', {
    staticClass: "is-added",
    on: {
      "click": function($event) {
        _vm.removeOfList(_vm.roomId)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("cancel")])]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.room.isSelected),
      expression: "room.isSelected"
    }],
    attrs: {
      "type": "checkbox",
      "hidden": "",
      "disabled": _vm.isAdded,
      "name": "rooms",
      "id": _vm.labelFor
    },
    domProps: {
      "checked": Array.isArray(_vm.room.isSelected) ? _vm._i(_vm.room.isSelected, null) > -1 : (_vm.room.isSelected)
    },
    on: {
      "change": function($event) {
        _vm.onChange(_vm.room)
      },
      "__c": function($event) {
        var $$a = _vm.room.isSelected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.room.isSelected = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.room.isSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.room.isSelected = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    class: {
      'disabled': _vm.isAdded, 'label-with-circle': _vm.showCircle
    },
    style: (("background-color: " + _vm.backgroundColor)),
    attrs: {
      "for": _vm.labelFor
    }
  }, [(_vm.showCircle) ? _c('div', {
    staticClass: "check-circle-container"
  }, [_c('span', {
    staticClass: "check-circle",
    class: {
      'close': _vm.isAdded
    }
  }, [(_vm.isAdded) ? _c('v-btn', {
    staticClass: "remove-icon",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.removeOfList(_vm.roomId)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), (!_vm.isAdded && _vm.room.isSelected) ? _c('v-icon', [_vm._v("check")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.name) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.name))])]) : _c('div', [_c('p', [_vm._v(_vm._s(_vm.number))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.code))]), _vm._v(" "), (_vm.showCircle && _vm.isAdded) ? _c('span', {
    staticClass: "name-state"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.stateCode) + "\n\t\t\t")]) : _vm._e()]), _vm._v(" "), (_vm.statusIcon) ? _c('div', {
    staticClass: "chip-icon",
    class: {
      'top-status': _vm.nameState
    }
  }, [_c('span', {
    class: ("sprite-states " + _vm.statusIcon)
  })]) : (_vm.statusIconImg) ? _c('div', {
    staticClass: "chip-icon",
    class: {
      'top-status': _vm.nameState
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.statusIconImg,
      "alt": ""
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.nameState) ? _c('div', {
    staticClass: "name-label"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.nameState) + "\n\t")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35d1e9a8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/RoomStatus.vue
// module id = 738
// module chunks = 108